/**
 * The button, in the Study's hand. One element, five voices — the exact
 * grammar of global.css: primary wears the room's accent; platform chrome
 * wears ink; releasing something into the world is sage (ok); ghost and
 * quiet recede. This is a thin wrapper over the `.btn-*` component classes
 * (no new CSS) — it only picks the class and forwards every native
 * <button> prop, so callers keep `type`, `onClick`, `disabled`, refs, etc.
 */
import { forwardRef } from "react";
import type { ButtonHTMLAttributes } from "react";

export type ButtonVariant = "accent" | "ink" | "ok" | "ghost" | "quiet";

const VARIANT_CLASS: Record<ButtonVariant, string> = {
  accent: "btn-accent",
  ink: "btn-ink",
  ok: "btn-ok",
  ghost: "btn-ghost",
  quiet: "btn-quiet",
};

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = "accent", className, type = "button", ...rest },
  ref,
) {
  const classes = className ? `${VARIANT_CLASS[variant]} ${className}` : VARIANT_CLASS[variant];
  return <button ref={ref} type={type} className={classes} {...rest} />;
});
